import React, { useEffect, useState } from 'react';
import { Grid,Box,Typography, Divider} from '@mui/material';
import {IconButton,Button,Tooltip } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer,Legend ,Tooltip as Tp} from 'recharts';
import {ChartAxis, ChartBar, ChartBullet, ChartBulletQualitativeRange, ChartThemeColor} from '@patternfly/react-charts';
// import Dataset from '@mui/icons-material/Dataset';
// import { dir } from 'console';
// import { position } from 'stylis';
// import theme from '../../../../theme';
// import {
//   ChartBullet,
//   ChartAxis,
//   ChartBar,
//   ChartBulletQualitativeRange,
//   ChartThemeColor
// } from '@patternfly/react-charts';

const TKCart = (props:any) => {
    let{kr,personPicture}=props || {};
    let{name,meetValue,responsibleName,lineChart,realMeetValue,pointingSystemType,keyResultType,score
     ,ziroValue , threeValue, sevenValue, oneValue,max, positive,responsibleId}=kr || {};

     const [daataa, setdaataa] = useState<any>([]);
     useEffect(() => {
      if (lineChart) {
        const validData = lineChart.filter((item : any) => 
          item.reportScore !== null && item.reportScore !== undefined && !isNaN(item.reportScore) &&
          item.newValue !== null && item.newValue !== undefined && !isNaN(item.newValue)
      );
       setdaataa(validData);
      }
    }, lineChart);

     const CustomTooltip = ({ active, payload, label } : any) => {
      if (active && payload && payload.length) {
        return (
          <div className="custom-tooltip" style={{ backgroundColor: '#00387C', color : '#fff' ,padding: '10px', border: '4px solid #ccc' }}>
        <p className="label">{`تاریخ: ${label}`}</p>
        <p>{`امتیاز: ${payload[0] !== null && payload[0] !== undefined ? payload[0].value : '-'}`}</p>
        <p>{`مقدار جدید: ${payload[1] !== null && payload[1] !== undefined ? payload[1].value : '-'}`}</p>
      </div>
        );
      }
    
      return null;
    };

    
  return (  
    
    <Grid container boxShadow={4} bgcolor={'white'} borderRadius={4} p={2} width={'100%'} >
        <Grid item xs={12}  >
        <Grid container >
        <Grid item xs={12}  >
        <Box 
        display={'flex'} 
        width={'100%'}
        flexDirection={'row-reverse'}
        justifyContent={'start'} > 
        
        <Box 
        display={'flex'} 
        width={'100%'}
       >
        <Typography px={1}  variant='body1'  fontSize={'14px'}  fontWeight={900} >نتیجه:</Typography>{
                  name.length > 66 ? <Tooltip  sx={{ fontSize: '1.5rem !important' }} title={name}>
               <Typography  textAlign={'left'}   variant='body1'sx={{ fontSize: '14px !important', fontWeight:'900',color: 'black',cursor:'pointer'}}   >{name.slice(0,66)}</Typography>
            </Tooltip> : <Typography textAlign={'left'} sx={{ fontSize: '14px !important',fontWeight:'900', color: 'black',cursor:'pointer'}}    >
              {
                 name
              }

            </Typography>
       }
        </Box>
        </Box>
        </Grid>
        </Grid>
        </Grid>
        <Grid item xs={12}  >
        <Box 
        display={'flex'} 
        width={'100%'}
        flexDirection={'row-reverse'}
        justifyContent={'space-around'} > 
        <Box 
        display={'flex'} 
        justifyContent={'start'} boxShadow={5} borderRadius={'50%'}
        bgcolor={score >= 70 ?'#d5f7d4' : score <70 && score > 30 ? '#FFF8D0': '#FFEEE5 '}
        color={score>= 70 ?'#125610' : score <70 && score > 30 ? '#6B6440': '#993600 '}
        textAlign={'center'}>
        <Typography px={1} textAlign={'center'} variant='button' fontSize={'15px'} fontWeight={150}> امتیاز: {score}</Typography>
        </Box>
        <Box 
        display={'flex'} 
        justifyContent={'start'} flexDirection={'column'} marginRight={3} boxShadow={5} borderRadius={'50%'}
        bgcolor={score>= 70 ?'#d5f7d4' : score <70 && score > 30 ? '#FFF8D0': '#FFEEE5 '}
        color={score>= 70 ?'#125610' : score <70 && score > 30 ? '#6B6440': '#993600 '}
        textAlign={'center'}>
        <Typography px={1} alignItems={'center'} textAlign={'center'} variant='button' fontSize={'15px'} fontWeight={100}> مقدار: </Typography>
        {
              meetValue.length > 6 ? <Tooltip  sx={{ fontSize: '1.5rem !important' }} title={meetValue}>
            <Typography  textAlign={'center'} variant='button'sx={{ fontSize: '14px !important', fontWeight:'100',cursor:'pointer'}}   >{meetValue.slice(0,6)}</Typography>
            </Tooltip> : <Typography  textAlign={'center'} variant='button' sx={{ fontSize: '14px !important',fontWeight:'100',cursor:'pointer'}}    >
              {
                 meetValue
              }
            </Typography>
       }
        </Box>
        <Box width={'100%'}display={'flex'} flexDirection={'row-reverse'} alignItems={'center'} justifyContent={'start'}>
        <Box>
        <Typography   fontSize={'13px'} variant='button' fontWeight={900} color={'black'} >مسئول: {
            responsibleName} </Typography>
        </Box>
        <Box px={0.5}>
        {
          <img src={
            personPicture !== null && personPicture !== undefined &&
            personPicture.filter((x:any)=>x.personId === responsibleId)[0] !== null &&
            personPicture.filter((x:any)=>x.personId === responsibleId)[0]!== undefined
            ?
            personPicture.filter((x:any)=>x.personId === responsibleId)[0].pictureBase64String
            :''
          } width={'23px'} style={{borderRadius:'50%'}} />
        }
        </Box>
      </Box>
      </Box>

        </Grid>
        <Grid container justifyContent="center" width={'100%'} height={'100%'}>
          {
            positive === true ?
            <ChartBullet
            ariaDesc=""
            ariaTitle=""
            axisComponent={
              <ChartAxis 
                tickValues={pointingSystemType === 'Regularly' ? [0, 100] : [0, 30, 70, 100]}
              tickFormat={(val: number) => {
                switch (val) {
                  case 0:
                    return '0';
                  case 30:
                    return '30';
                  case 70:
                    return '70';
                  case 100:
                    return '100';
                  default:
                    return '';
                }
          }}
            />
          }
          comparativeWarningMeasureData={sevenValue !== null ? [{ name: sevenValue, y: 70 }] : []}
          constrainToVisibleArea
          height={150}
          labels={({ datum }) => `سطح ${datum.y} : ${datum.name}`}
          maxDomain={{y: 0}}
          minDomain={{y: 100}}
          name=""
          themeColor={ChartThemeColor.purple}
          primarySegmentedMeasureData={[{ name: 'امتیاز', y: score}]}
          qualitativeRangeData={
            pointingSystemType === 'Regularly'  ? 
            [
              { name: ziroValue , y: 0 /*, style:{ fill: 'green' }*/},
              { name: oneValue , y: 100 },
            ]:
            [
              { name: ziroValue  , y: 0  /*, fill: 'green' /*,style:{ color: 'green' }*/},
              { name: threeValue  , y: 30 }, 
              { name: sevenValue  , y: 70 }, 
              { name: oneValue  , y: 100 },
            ]
            }
          width={600}
          />
          :
          <ChartBullet
          ariaDesc=""
          ariaTitle=""
          axisComponent={
            <ChartAxis 
              tickValues={pointingSystemType === 'Regularly' ? [0, 100] : [0, 30, 70, 100]}
              tickFormat={(val: number) => {
                switch (val) {
                  case 0:
                    return '0';
                  case 30:
                    return '30';
                  case 70:
                    return '70';
                  case 100:
                    return '100';
                  default:
                    return '';
                }
              }}
            />
          }
          comparativeWarningMeasureData={sevenValue !== null ? [{ name: sevenValue, y: 70 }] : []}
          constrainToVisibleArea
          height={150}
          labels={({ datum }) => `سطح ${datum.y} : ${datum.name}`}
          minDomain={{y: 0}}
          maxDomain={{y: 100}}
          name=""
          primarySegmentedMeasureData={[{ name: 'امتیاز', y: score}]}
          qualitativeRangeData={
            pointingSystemType === 'Regularly'  ? 
            [
              { name: ziroValue , y: 0 },
              { name: oneValue , y: 100 },
            ]:
            [
              { name: ziroValue  , y: 0 , color:'red'},
              { name: threeValue  , y: 30, color:'red' }, 
              { name: sevenValue  , y: 70 , color:'red'}, 
              { name: oneValue  , y: 100 , color:'red'},
            ]
            }
          width={600}
          />
        }
        </Grid>
        {
          lineChart !== null && lineChart !== undefined
          && lineChart.length !== 0 ?
         <Grid container item  xs={16} justifyContent="center" width={'400px'} height={'300px'}>
          <Typography px={1} variant='button' fontWeight={900} color={'black'} > سابقه ارزیابی های اخیر</Typography>
          <ResponsiveContainer width="100%" height="100%">
          <LineChart
            width={100000}
            height={410000}
            data={daataa}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <XAxis 
              dataKey="meetingDate" 
              tickMargin={10}  // فاصله دادن اعداد از محور X
            />

            <YAxis 
              yAxisId="left" 
              color='#e28743' 
              label={{
                value: 'امتیاز',
                style: { fill: '#e28743', fontSize: 12}
              }} 
              domain={[0, 100]}  
              tickMargin={15}
              // tickSize={15}  // فاصله دادن اعداد از محور Y (چپ)
              tickLine={false} // پنهان کردن خط‌های کوچک کنار اعداد
            />

            <YAxis 
              yAxisId="right" 
              color='#000' 
              label={{
                value: 'مقدار جدید',
                style: { fontSize: 12 }
              }}  
              orientation="right"
              domain={max === 0 ? []:[0, max]}  
              tickMargin={20}  // فاصله دادن اعداد از محور Y (راست)
              tickLine={false} // پنهان کردن خط‌های کوچک کنار اعداد
            />
            <Tp 
             content={<CustomTooltip />}
            />
            <Line yAxisId="left" type="monotone" dataKey="reportScore"  stroke="#e28743" activeDot={{ r: 6 }} />
            {/* {keyResultType !== 'Phase' ? 
            <Line yAxisId="right" type="monotone" dataKey="newValue" stroke="#000" activeDot={{ r: 6 }} /> : <></>
            } */}
            <Line yAxisId="right" type="monotone" dataKey="newValue" stroke="#000" activeDot={{ r: 6 }} />
          </LineChart>
         </ResponsiveContainer>
          </Grid>
          :
          <Grid xs={12}>
          <Box  display={'flex'} alignItems={'center'} justifyContent={'space-between'} textAlign={'center'}>   
        </Box>
          </Grid>
        }
        <Grid xs={12}>
        <Box  display={'flex'} alignItems={'center'} justifyContent={'space-between'} textAlign={'center'}>   
      </Box>
        </Grid>
   </Grid>
  )
}

export default TKCart